import { errorText } from '../../../shared/toastHelper';

export default function apiErrorMessage(error, fallback = 'An unexpected error occurred') {
  return errorText(error, fallback);
}
